import React, {Component} from 'react';
import {EditorState, convertFromRaw} from 'draft-js';
import Editor from 'draft-js-plugins-editor';
import Breadcrumbs from './breadcrumb';

class MainContent extends Component {
  constructor(props){
    super(props);
    
    this.state = {
      editorState: EditorState.createEmpty()    
    }

    this.parsePropsToDocId = this.parsePropsToDocId.bind(this);
  }

  componentDidMount() {
    this.getContent();
  }

  componentWillReceiveProps(newProps){
    if(this.props === newProps) { return; }

    this.props = newProps;
    this.getContent();

  }

  parsePropsToDocId() {
    let docParams = this.props.location.pathname.split('/');
    docParams.shift();
    //return docParams.join('/');
    return docParams.join(':');
  }

  getContent(){
    const docId = this.parsePropsToDocId();
    let apiUrl = `${window.location.protocol}//${window.location.host}/api/pages/${docId}`;
    fetch(apiUrl)
      .then(res => res.json())
      .then(data => {
        this.setState({
          title: data.document.title,
          editorState: EditorState.createWithContent(convertFromRaw(data.documentContent)),
          sectionTitle: data.section.title
        });
      });
  }

  render(){
    return(
      <div>
        <Breadcrumbs sectionTitle={this.state.sectionTitle} documentTitle={this.state.title} documentPath={this.props.location.pathname} />
        <div className="editor-readonly-content">
          <h1>{this.state.title}</h1>
          <Editor
            name="displayEditor"
            editorState={this.state.editorState}  
            readOnly={true}
          />
        </div>
      </div>
    );
  }
}

export default MainContent;